import { render, staticRenderFns } from "./IcDownload.vue?vue&type=template&id=3f466370&scoped=true"
import script from "./IcDownload.vue?vue&type=script&lang=js"
export * from "./IcDownload.vue?vue&type=script&lang=js"
import style0 from "./IcDownload.vue?vue&type=style&index=0&id=3f466370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f466370",
  null
  
)

export default component.exports